import { render, staticRenderFns } from "./HeaderAppTips.vue?vue&type=template&id=1ba2ac02&scoped=true&"
import script from "./HeaderAppTips.vue?vue&type=script&lang=js&"
export * from "./HeaderAppTips.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAppTips.vue?vue&type=style&index=0&id=1ba2ac02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba2ac02",
  null
  
)

export default component.exports